import { create } from "zustand"

interface SubmissionSheetState {
  id: string
  conversationCode?: string
  setId: (id: string, conversationCode?: string) => void
}

export const useShowSubmission = create<SubmissionSheetState>((set) => ({
  id: "",
  setId: (id, conversationCode) => set({ id, conversationCode })
}))
